import { render } from "./EnBeverage.vue?vue&type=template&id=4b2c34e0&scoped=true"
import script from "./EnBeverage.vue?vue&type=script&lang=js"
export * from "./EnBeverage.vue?vue&type=script&lang=js"

import "./EnBeverage.vue?vue&type=style&index=0&id=4b2c34e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b2c34e0"]])

export default __exports__